import _fetch, { type ClientFetchOptions } from '@avalara/bat-apps-shared/lib/client-fetch';
import type { DefaultErrorDetails, Result } from '@avalara/types/index';

import { loadingDataFinish, loadingDataStart } from '../store/data';
import { getOwdBearerToken } from './owd-bearer-token';

import type { Dispatch } from '@avalara/types/actions';
import type { AdditionalHeaders } from '@avalara/types/index';

type FetchParams = {
  retry?: boolean;
  showLoadingWheel?: boolean;
};

/** Simple fetch helper */
const fetch = (dispatch: Dispatch, fetchParams: FetchParams = {}) =>
  async function f<S, E = DefaultErrorDetails>(
    url: RequestInfo,
    params: RequestInit = {},
    additionalHeaders?: AdditionalHeaders,
  ): Promise<Result<S, E>> {
    const baseHeaders = {
      'cache-control': 'no-cache',
      'Content-Type': 'application/json',
    };

    const headers = {
      ...baseHeaders,
      ...additionalHeaders,
    };

    const accessToken = await getOwdBearerToken();
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    if (fetchParams.showLoadingWheel !== false) dispatch(loadingDataStart());

    const fetchOptions: ClientFetchOptions = {
      url,
      params: {
        ...params,
        credentials: 'include',
        headers,
      },
      timeout: 120000,
    };

    let result = await _fetch<S, E>(fetchOptions);
    if (fetchParams.retry != null && !result.ok) {
      result = await _fetch<S, E>(fetchOptions);
    }

    if (fetchParams.showLoadingWheel !== false) dispatch(loadingDataFinish());

    return result;
  };

export default fetch;
